var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bloc-headline"},[_c('div',{staticClass:"headline-title",class:{bg: _vm.bg, dotted: _vm.dotted}},[_vm._t("default")],2),(!_vm.dotted)?_c('div',{staticClass:"headline-shadow-line"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }